import { useCurrentEnvironment } from '@/react/hooks/useCurrentEnvironment';
import { isKubernetesEnvironment } from '@/react/portainer/environments/utils';
import { PolicyOverrideAlert } from '@/react/portainer/policies/components/PolicyOverrideAlert';

import { PageHeader } from '@@/PageHeader';

import { getRegistryPolicy } from '../../utils/getRegistryPolicy';

import { EnvironmentRegistriesDatatable } from './EnvironmentRegistriesDatatable';

export function ListView() {
  const { data: environment } = useCurrentEnvironment();
  const registryPolicy = getRegistryPolicy(environment);
  const hasRegistryPolicyApplied = !!registryPolicy?.policyID;
  const policyName = registryPolicy?.policyName || '';
  const policyId = registryPolicy?.policyID || 0;

  return (
    <>
      <PageHeader
        title="Environment registries"
        breadcrumbs="Registry management"
        reload
      />

      {hasRegistryPolicyApplied && (
        <div className="row">
          <div className="col-sm-12">
            <PolicyOverrideAlert
              policyType={
                isKubernetesEnvironment(environment!.Type)
                  ? 'registry-k8s'
                  : 'registry-docker'
              }
              policyId={policyId}
              policyName={policyName}
            />
          </div>
        </div>
      )}

      <EnvironmentRegistriesDatatable registryPolicy={registryPolicy} />
    </>
  );
}
